import { isStandardBackendError } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { ERROR_CODES } from '@dealstack/shared/lib/common/errors';

/** Another person in the deal already holds this TIN for the same country and TIN type. */
export const isTinInUseError = (error: unknown): boolean =>
	isStandardBackendError(error) && error.error?.code === ERROR_CODES.PROJECT.CAP.PERSONS[120405];
